import DrinkCalculator from './DrinkCalculator';

export default DrinkCalculator;
